import axios from "../../lib/axios";
import checkIsLocalhost from "../../utils/checkIsLocalhost";
import { BarcodeType } from "../../types/barcode.types";
import { FilterType, IFilter } from "../../types/filters.types";
import { LocationCoords } from "../../types/permission.types";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "/";

/* istanbul ignore next */
export const getWarehouseKPIData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedWarehouseKPIValues(ImpactInput: {CIC: "${filters.cic}", Warehouse: ${filters.warehouse}, DCDivision: ${filters.warehouseDivision}, DistributionCenter: ${filters.distribution}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}})
    {
      itemType {type subType}
      onOrderSellingUnits {unitCount daysOfSOH itemTimeSupply}
      inTransitToDcSellingUnits {unitCount daysOfSOH itemTimeSupply}
      dcInventorySellingUnits {unitCount daysOfSOH itemTimeSupply}

      onOrderShippingUnits {unitCount daysOfSOH itemTimeSupply}
      inTransitToDcShippingUnits {unitCount daysOfSOH itemTimeSupply}
      dcInventoryShippingUnits {unitCount daysOfSOH itemTimeSupply}

      onOrderVendorUnits {unitCount daysOfSOH itemTimeSupply}
      inTransitToDcVendorUnits {unitCount daysOfSOH itemTimeSupply}
      dcInventoryVendorUnits {unitCount daysOfSOH itemTimeSupply}

      fourWeekFrwdDemandSellingUnits
      eightWeekHstrSelnSellingUnits

      fourWeekFrwdDemandShippingUnits
      eightWeekHstrSelnShippingUnits

      fourWeekFrwdDemandVendorUnits
      eightWeekHstrSelnVendorUnits

      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/cross-network-health`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

/* istanbul ignore next */
export const getWarehouseKPIDataRetailOps = (
  filters: IFilter,
): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedWarehouseKPIValues(ImpactInput: {CIC: "${filters.cic}", Warehouse: ${filters.warehouse}, DCDivision: ${filters.warehouseDivision}, DistributionCenter: ${filters.distribution}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}})
    {
      itemType {type subType}
      onOrderSellingUnits {unitCount avgWeeklyMovement daysOfSupply}
      inTransitToDcSellingUnits {unitCount avgWeeklyMovement daysOfSupply}
      dcInventorySellingUnits {unitCount avgWeeklyMovement daysOfSupply}

      onOrderShippingUnits {unitCount avgWeeklyMovement daysOfSupply}
      inTransitToDcShippingUnits {unitCount avgWeeklyMovement daysOfSupply}
      dcInventoryShippingUnits {unitCount avgWeeklyMovement daysOfSupply}

      onOrderVendorUnits {unitCount avgWeeklyMovement daysOfSupply}
      inTransitToDcVendorUnits {unitCount avgWeeklyMovement daysOfSupply}
      dcInventoryVendorUnits {unitCount avgWeeklyMovement daysOfSupply}

      twentySixWeekHstrSalesSellingUnits
      twentySixWeekHstrSalesShippingUnits
      twentySixWeekHstrSalesVendorUnits

      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/cross-network-health`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

/* istanbul ignore next */
export const getStoreKPIData = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedStoreKPIValues(ImpactInput: {CIC: "${filters.cic}", Warehouse: ${filters.warehouse}, DCDivision: ${filters.warehouseDivision}, DistributionCenter: ${filters.distribution}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}})
    {
      itemType {type subType}

      inTransitToStoreSellingUnits {unitCount daysOfSOH itemTimeSupply}
      storeInventorySellingUnits {unitCount daysOfSOH itemTimeSupply}

      inTransitToStoreShippingUnits {unitCount daysOfSOH itemTimeSupply}
      storeInventoryShippingUnits {unitCount daysOfSOH itemTimeSupply}

      inTransitToStoreVendorUnits {unitCount daysOfSOH itemTimeSupply}
      storeInventoryVendorUnits {unitCount daysOfSOH itemTimeSupply}

      storeOnOrderSellingUnits {unitCount daysOfSOH itemTimeSupply}

      storeOnOrderShippingUnits {unitCount daysOfSOH itemTimeSupply}

      storeOnOrderVendorUnits {unitCount daysOfSOH itemTimeSupply}

      fourWeekFrwdDemandSellingUnits
      eightWeekHstrSelnSellingUnits

      fourWeekFrwdDemandShippingUnits
      eightWeekHstrSelnShippingUnits

      fourWeekFrwdDemandVendorUnits
      eightWeekHstrSelnVendorUnits

      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/cross-network-health`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

/* istanbul ignore next */
export const getStoreKPIDataRetailOps = (filters: IFilter): Promise<any> => {
  const isLocalhost = checkIsLocalhost();

  const raw = `{
    getUnifiedStoreKPIValues(ImpactInput: {CIC: "${filters.cic}", Warehouse: ${filters.warehouse}, DCDivision: ${filters.warehouseDivision}, DistributionCenter: ${filters.distribution}, RetailDivision: ${filters.retailDivision}, RetailStore: ${filters.retailStore}, Department: ${filters.department}, RetailSection: ${filters.retailSection}, SMIC: ${filters.smic}, UPC: ${filters.upc}})
    {
      itemType {type subType}

      inTransitToStoreSellingUnits {unitCount avgWeeklyMovement daysOfSupply}
      storeInventorySellingUnits {unitCount avgWeeklyMovement daysOfSupply}

      inTransitToStoreShippingUnits {unitCount avgWeeklyMovement daysOfSupply}
      storeInventoryShippingUnits {unitCount avgWeeklyMovement daysOfSupply}

      inTransitToStoreVendorUnits {unitCount avgWeeklyMovement daysOfSupply}
      storeInventoryVendorUnits {unitCount avgWeeklyMovement daysOfSupply}

      storeOnOrderSellingUnits {unitCount avgWeeklyMovement daysOfSupply}

      storeOnOrderShippingUnits {unitCount avgWeeklyMovement daysOfSupply}

      storeOnOrderVendorUnits {unitCount avgWeeklyMovement daysOfSupply}

      twentySixWeekHstrSalesSellingUnits
      twentySixWeekHstrSalesShippingUnits
      twentySixWeekHstrSalesVendorUnits

      errors { errorCode errorDescription }
    }
  }`;
  const url = `${baseUrl}sdiminventory/cross-network-health`;

  return axios.post(
    isLocalhost ? "/api/middleware" : url,
    isLocalhost ? { raw, url } : raw,
  );
};

export const getFilters = (
  type: string,
  query: string,
  pageNumber: number,
  filters: IFilter,
) =>
  axios.get(
    `/api/filters?type=${type}&query=${query}&pageNumber=${pageNumber}&filters=${JSON.stringify(
      filters,
    )}`,
  );

export const getDefaultFilters = (
  location: LocationCoords,
  extraFilters: FilterType[],
) =>
  axios.get(
    `/api/default-filters?lat=${location.latitude}&lng=${
      location.longitude
    }&extraFilters=${JSON.stringify(extraFilters)}`,
  );

export const getProductDescription = (data: string, type: BarcodeType) => {
  if (type === "cic") {
    return axios.get(`/api/product-description?cic=${data}`);
  }
  if (type === "upc") {
    return axios.get(`/api/product-description?upc=${data}`);
  }
};

export const getCICDetails = (data: string, type: BarcodeType) => {
  return axios.get(`/api/upc-details?cic=${data}`);
};
